<div class="card-body login-screen">
  <form (ngSubmit)="onSubmit(form.value)" [formGroup]="form" class="form form-no-width auto">
    <div [ngClass]="{ 'input-error': submitted && f.username.errors }">
      <label class="form-label mt0" for="username">{{ 'email_address' | translate }}</label>
      <input (ngModelChange)="emailChanged($event)" class="centered" formControlName="username" id="username" type="email">
      <div class="errors">
        <div *ngIf="f.username.errors?.required">{{ 'email_address.required' | translate }}</div>
        <div *ngIf="f.username.errors?.pattern">{{ 'email_address.invalid' | translate }}</div>
      </div>
    </div>
    <div class="spacer-small"></div>
    <div [ngClass]="{ 'input-error': submitted && f.password.errors }">
      <label class="form-label" for="password">{{ 'password' | translate }}</label>
      <div class="relative">
        <input appShowPasswordToggle class="centered" formControlName="password" id="password" type="password">
      </div>
      <div *ngIf="submitted && f.password.errors" class="errors">
        <div *ngIf="f.password.errors?.required">{{ 'password.required' | translate }}</div>
        <div *ngIf="f.password.errors?.minlength">{{ 'password.minLength' | translate }}</div>
      </div>
      <div class="error"><div *ngIf="message">{{message}}</div></div>
    </div>
    <div class="spacer"></div>
    <div class="flex space-between" id="login-or-register">
      <div>
        <button class="btn user inverted" style="margin-left: -15px;" type="submit">inloggen</button>
      </div>
      <div style="margin-top: 4px">
        <span class="link" routerLink="/registreren">registreer hier</span>
       <div style="margin-top: 7px"></div>
        <span class="link" routerLink="/wachtwoord-herstel">wachtwoord vergeten?</span>
      </div>
    </div>
  </form>
</div>
